import dayjs from "dayjs";

import { supabase } from "~/integrations/supabase/client";

export interface AuditLogEntry {
  id: string;
  movement_id: string;
  move_number: string;
  action: "publish" | "unpublish";
  performed_by: string;
  performed_at: string;
  move_date: string;
  company_id: string;
  performer?: {
    name: string;
    lastname: string;
    email: string;
  };
}

export interface AuditLogFilters {
  year?: number;
  month?: number;
  action?: "publish" | "unpublish";
  companyId?: string;
}

export interface LogActionParams {
  movementId: string;
  moveNumber: string;
  action: "publish" | "unpublish";
  performedBy: string;
  moveDate: string;
  companyId: string;
}

export const auditLogService = {
  async log(params: LogActionParams): Promise<void> {
    const { error } = await supabase
      .from("account_movement_audit_log")
      .insert({
        movement_id: params.movementId,
        move_number: params.moveNumber,
        action: params.action,
        performed_by: params.performedBy,
        move_date: params.moveDate,
        company_id: params.companyId,
      });

    if (error) throw error;
  },

  async getAll(filters?: AuditLogFilters): Promise<AuditLogEntry[]> {
    let query = supabase
      .from("account_movement_audit_log")
      .select(
        `
        *,
        performer:performed_by(name, lastname, email)
      `
      )
      .order("performed_at", { ascending: false });

    if (filters?.year && filters?.month) {
      const startDate = dayjs(`${filters.year}-${filters.month}-01`)
        .startOf("month")
        .format("YYYY-MM-DD");
      const endDate = dayjs(`${filters.year}-${filters.month}-01`)
        .endOf("month")
        .format("YYYY-MM-DD");
      query = query.gte("move_date", startDate).lte("move_date", endDate);
    }

    if (filters?.action) {
      query = query.eq("action", filters.action);
    }

    if (filters?.companyId) {
      query = query.eq("company_id", filters.companyId);
    }

    const { data, error } = await query;
    if (error) throw error;
    return data as AuditLogEntry[];
  },
};
